<template>
  <div class="note">
    <div v-if="icon" class="note__side">
      <BaseIcon v-bind="icon" />
    </div>
    <div v-if="text" class="note__main">
      <BaseText v-bind="text" v-html="text.text" />
    </div>
    <slot />
  </div>
</template>

<script>
import BaseText from '@/components/BaseText.vue';
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'BaseNote',
  components: {
    BaseText,
    BaseIcon,
  },
  props: {
    icon: {
      type: Object,
      default: null,
    },
    text: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="stylus">
.note
  display flex
  align-items center
  background-color $c_bright
  color #fff
  padding 0.8em 1.6em

  &__side
    width 2em

  &__main
    flex-grow 1
    flex-basis 0
    max-width 100%
    ~/__side ~ &
      max-width calc(100% - 2em)
      padding-left 1em
</style>
